// v-server-table default options
export const serverTableOptions = {
    texts: {
        count: "Affiche {to} des {count} contenus | {count} contenus | un contenu",
        filter: "",
        filterPlaceholder: "Recherchez ici",
        limit: "Fiches:",
        page: "Page:",
        noResults: "Aucune fiche trouvée",
        filterBy: "Filtre par {column}",
        loading: 'Chargement...',
        defaultOption: 'Selectionner {column}'
    }
};

// mini-toastr config
export const toastrOptions = {
    timeout: 4000,
};


// WEBPACK FOOTER //
// ./src/thirdparty/options.js